import { render, staticRenderFns } from "./VolumeSlider.vue?vue&type=template&id=6cbae13b&scoped=true&"
import script from "./VolumeSlider.vue?vue&type=script&lang=js&"
export * from "./VolumeSlider.vue?vue&type=script&lang=js&"
import style0 from "./VolumeSlider.vue?vue&type=style&index=0&id=6cbae13b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbae13b",
  null
  
)

export default component.exports